import React from "react";
import styles from "./index.module.css";
import Icon1 from "@/assets/images/m-scene-icon-1.png";
import Icon2 from "@/assets/images/m-scene-icon-2.png";
import Icon3 from "@/assets/images/m-scene-icon-3.png";
import Icon4 from "@/assets/images/m-scene-icon-4.png";
import Icon5 from "@/assets/images/m-scene-icon-5.png";

const Scene = () => {
  const list = [
    {
      title: "职场办公",
      descs: [
        "运营转正述职报告",
        "产品经理季度总结",
        "互联网AIGC应用领域的行业分析报告",
      ],
      img: Icon1.src,
      color: "#FFFAEE",
      fill: "#F9D674",
    },
    {
      title: "人事行政",
      descs: ["公司秋季团建方案", "新员工入职培训", "公司管理制度培训"],
      img: Icon2.src,
      color: "#F4FAFF",
      fill: "#ABD7FF",
    },
    {
      title: "教师学生",
      descs: [
        "新学期家长会课件",
        "大学生职业生涯规划",
        "大学生校园艺术节活动方案",
      ],
      img: Icon3.src,
      color: "#F3FCFB",
      fill: "#BBFFE2",
    },
    {
      title: "营销策划",
      descs: ["双11商场线下促销活动", "美妆产品活动推广方案"],
      img: Icon4.src,
      color: "#FFF4F4",
      fill: "#FFC4CC",
    },
    {
      title: "医疗医护",
      descs: ["秋冬如何预防流感分享", "医疗卫生常识科普"],
      img: Icon5.src,
      color: "#F3FFE6",
      fill: "#C7FB91",
    },
  ];

  return (
    <div className={styles.scene}>
      <div className={styles.sceneTitle}>覆盖多场景 满足多人群PPT需求</div>
      <div className={styles.sceneContent}>
        {list.map((item, index) => (
          <div
            className={styles.sceneContentItem}
            key={index}
            style={{ backgroundColor: item.color }}
          >
            <div className={styles.sceneContentItemTitle}>
              {/* eslint-disable-next-line @next/next/no-img-element */}
              <img
                className={styles.sceneContentItemImg}
                src={item.img}
                alt={item.title}
              />
              <div>{item.title}</div>
            </div>
            <ul className={styles.sceneContentItemDesc}>
              {item.descs.map((item, idx) => (
                <li key={`desc-${idx}`}>{item}</li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
};

export default React.memo(Scene);
